import { useLocation } from "react-router";
import { ButtonLink } from "@oai/platform/ui/Button";
import { ArrowUpRight } from "@oai/platform/ui/Icon";

import { useCookieConsent } from "@/hooks/useCookieConsent";
import { useClientTelemetry } from "@/lib/clientTelemetry";
import { captureGoogleAdsClickIdFromCurrentUrl } from "@/lib/googleAdsMeasurement";
import { captureLinkedInAdsClickIdFromCurrentUrl } from "@/lib/linkedInAdsMeasurement";
import { captureMetaAdsClickIdFromCurrentUrl } from "@/lib/metaAdsMeasurement";
import { captureRedditAdsClickIdFromCurrentUrl } from "@/lib/redditAdsMeasurement";

import type { AdsLandingCta } from "./types";

export function CtaButton({
  cta,
  showTrailingIcon = false,
}: {
  cta: AdsLandingCta;
  showTrailingIcon?: boolean;
}) {
  const { logEvent } = useClientTelemetry();
  const location = useLocation();
  const { isConsentResolved, marketingConsentEnabled } = useCookieConsent();
  const buttonProps =
    cta.variant === "accent" ? { color: "primary", variant: "solid" as const }
    : cta.variant === "primary" ? { color: "primary", variant: "soft" as const }
    : { color: "secondary", variant: "ghost" as const };

  return (
    <ButtonLink
      href={cta.href}
      as="a"
      color={buttonProps.color}
      variant={buttonProps.variant}
      size="lg"
      pill
      external={cta.external}
      data-analytics-action={cta.analyticsAction}
      onClick={() => {
        if (location.search && isConsentResolved && marketingConsentEnabled) {
          captureGoogleAdsClickIdFromCurrentUrl();
          captureLinkedInAdsClickIdFromCurrentUrl();
          captureMetaAdsClickIdFromCurrentUrl();
          captureRedditAdsClickIdFromCurrentUrl();
        }
        if (cta.analyticsAction) {
          logEvent("landing_cta_clicked", cta.analyticsAction);
        }
      }}
    >
      {cta.label}
      {showTrailingIcon ?
        <ArrowUpRight />
      : null}
    </ButtonLink>
  );
}
